// extracted by mini-css-extract-plugin
module.exports = {"list_item":"styles_list_item__1w5pw"};